import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

export enum MessageAction { HIDE, SHOW}
export enum MessageLevel { INFO = 'info', ERROR = 'error', SUCCESS = 'success', WARNING = 'warning'}
export interface IMessage { message: string; level: MessageLevel; details?: any; reference?: string; }

@Injectable({
  providedIn: 'root'
})
export class MessageNotificationService {
  private messageSubject = new Subject<{message: IMessage, action: MessageAction}>();
  message$ = this.messageSubject.asObservable();

  /**
   * Displays an info message.
   * @param message The main info message/title to display
   * @param details Additional info rendered in a p tag
   */
  info(message: string, details?: any) {
    this.genericMessage(message, MessageLevel.INFO, details);
  }

  /**
   * Displays a success message.
   * @param message The main success message/title to display
   * @param details Additional info rendered in a p tag
   */
  success(message: string, details?: any) {
    this.genericMessage(message, MessageLevel.SUCCESS, details);
  }

  /**
   * Displays a warning message.
   * @param message The main warning message/title to display
   * @param details Additional info rendered in a p tag
   */
  warning(message: string, details?: any) {
    this.genericMessage(message, MessageLevel.WARNING, details);
  }

  /**
   * Displays an error message.
   * @param message The main error message/title to display
   * @param error Error returned
   */
  error(message: string, error?: any) {
    this.genericMessage(message, MessageLevel.ERROR, error);
  }

  private genericMessage(message: string,  messageLevel: MessageLevel, details?: any) {
    const messageData: IMessage = {
      message: message,
      level: messageLevel,
      details: details,
    };
    this.messageSubject.next({ message: messageData, action: MessageAction.SHOW });
  }

  hide(message: IMessage): void {
    this.messageSubject.next({ message: message, action: MessageAction.HIDE });
  }
}
